export enum PaymentPurpose {
    extraCredits = 'extra-credits',
    paymentMethod = 'payment-method',
    subscription = 'subscription',
    freeTrialPaymentMethod = 'free-trial-payment-method',
}
